import Typography from '@mui/material/Typography';

function Sketching(){
    return(
        <>
            <Typography variant="h6" color="white">
                Section in developement, I apologize for the inconvenient...
            </Typography>
        </>
    )
}
export default Sketching;